import { apiDelete, apiGet, apiPatch, apiPost } from "acds-react-core";
import _ from "lodash";
import { toast } from "react-toastify";
import { all, put, select, takeEvery, takeLatest, call } from "redux-saga/effects";
import { PRODUCT_REVIEW_CONSTANTS } from "../../constants/constants";
import {
  DO_UPDATE_PRODUCT_REVIEW_PHOTOS,
  GET_PRODUCT_NEXT_REVIEWS_ERROR,
  GET_PRODUCT_NEXT_REVIEWS_SUCCESS,
  GET_PRODUCT_REVIEWS,
  GET_PRODUCT_REVIEWS_ERROR,
  GET_PRODUCT_REVIEWS_NEXT,
  GET_PRODUCT_REVIEWS_SUCCESS,
  GET_PRODUCT_REVIEW_LAST_UPDATED_DATE,
  GET_SELECTED_PRODUCT_DETAILS,
  GET_SELECTED_PRODUCT_DETAILS_SUCCESS,
  PRODUCT_REVIEW_UPLOAD_PRODUCT_PHOTO_ERROR,
  PRODUCT_REVIEW_UPLOAD_PRODUCT_PHOTO_SUCCESS,
  PUBLISH_SELECTED_PRODUCT_DETAILS,
  SET_PRODUCT_REVIEW_LAST_UPDATED_DATE,
  UPDATE_PRODUCT_REVIEW_STATUS,
  UPDATE_SELECTED_PRODUCT_DETAILS,
  UPDATE_SELECTED_PRODUCT_DETAILS_ERROR,
  UPDATE_SELECTED_PRODUCT_DETAILS_SUCCESS,
  GET_INGREDIENT_LOGS,
  SET_INGREDIENT_LOGS,
  SET_FETCHING_ERROR,
  GET_INGREDIENT_LOGS_NEXT,
  GET_BARCODE_MATCHES,
  GET_BARCODE_MATCHES_SUCCESS,
  GET_BARCODE_MATCHES_FAILURE,
} from "../actions/productReview";

const ERROR_TOAST_OPTIONS = {
  bodyClassName: "toast-body",
  style: {
    backgroundColor: "#414B4F",
    color: "#ffffff",
  },
  progressStyle: {
    background: "#E74C3C",
  },
  closeButton: true,
  position: "top-right",
  autoClose: 4000,
};

function* doGetProductReviewLastUpdatedDate(payload) {
  const status = _.get(payload, "payload", 1);
  const apiUrl = `api/products/last_updated_date/?status=${status}`;
  try {
    const response = yield apiGet(apiUrl);
    yield put({
      type: SET_PRODUCT_REVIEW_LAST_UPDATED_DATE,
      response,
    });
  } catch (error) {
    console.error(error);
  }
}

function* doGetProductReviews(payload) {
  const baseUrl = yield select((state) => state.env.api_root);

  const productReviewSearch = yield select((state) => state.productReviews.productReviewSearch);

  const productReviewApiPath = "/api/products";

  const listProductReviews = new URL(productReviewApiPath, baseUrl);

  if (_.has(payload, "payload.startDate")) {
    yield put({
      type: SET_PRODUCT_REVIEW_LAST_UPDATED_DATE,
      response: {
        from: _.get(payload, "payload.startDate"),
        to: _.get(payload, "payload.endDate"),
      },
    });
    listProductReviews.searchParams.set("updated_at__lte", _.get(payload, "payload.endDate"));
    listProductReviews.searchParams.set("updated_at__gte", _.get(payload, "payload.startDate"));
  } else {
    listProductReviews.searchParams.set("ordering", _.get(payload, "payload.sort"));
  }

  listProductReviews.searchParams.set("status", _.get(payload, "payload.currentViewChoice"));

  if (!_.isEmpty(productReviewSearch)) {
    listProductReviews.searchParams.set("name__icontains", productReviewSearch);
  }

  const apiUrl = _.replace(listProductReviews.toString(), baseUrl + "/", "");

  try {
    const listProductReview = yield apiGet(apiUrl);

    yield put({
      type: GET_PRODUCT_REVIEWS_SUCCESS,
      result: listProductReview,
    });
  } catch (error) {
    yield put({
      type: GET_PRODUCT_REVIEWS_ERROR,
      error,
    });
    console.log(error);
  }
}

function* doGetProductReviewsNext() {
  const baseUrl = yield select((state) => state.env.api_root);
  const fetchingProductReviews = yield select((state) => state.productReviews.fetchingProductReviews);
  const productReviewsNext = yield select((state) => state.productReviews.productReviewsNext);
  const productReviewsNextUrl = _.replace(productReviewsNext, baseUrl + "/", "");

  if (fetchingProductReviews) {
    return;
  }

  if (productReviewsNext.length > 0) {
    try {
      const productReviewNextResult = yield apiGet(productReviewsNextUrl);

      yield put({
        type: GET_PRODUCT_NEXT_REVIEWS_SUCCESS,
        result: productReviewNextResult,
      });
    } catch (error) {
      yield put({
        type: GET_PRODUCT_NEXT_REVIEWS_ERROR,
        error,
      });
      console.log(error);
    }
  }
}

function* doUpdateProductStatus(action) {
  const params = action;
  const id = params.payload.id;
  const payload = {
    status: params.payload.status,
  };

  const apiString = `api/products/${id}/`;

  try {
    yield apiPatch(apiString, payload);

    if (params.payload.status === 2) {
      toast.error("Product Rejected", {
        bodyClassName: "toast-body",
        style: {
          backgroundColor: "#414B4F",
          color: "#ffffff",
        },
        progressStyle: {
          background: "#E74C3C",
        },
        closeButton: true,
        position: "top-right",
      });
    } else if (params.payload.status === 0) {
      toast.success("Product Published", {
        bodyClassName: "toast-body",
        style: {
          backgroundColor: "#414B4F",
          color: "#ffffff",
        },
        progressStyle: {
          background: "#00889b",
        },
        closeButton: true,
        position: "top-right",
      });
    } else {
      toast.success("Product Saved", {
        bodyClassName: "toast-body",
        style: {
          backgroundColor: "#414B4F",
          color: "#ffffff",
        },
        progressStyle: {
          background: "#00889b",
        },
        closeButton: true,
        position: "top-right",
      });
    }
  } catch (error) {
    console.error(error);
  }
}

function* doSaveProductDetails(action) {
  const params = action;

  const { setFieldError } = params.payload;

  const payload = _.omit(params.payload.payload, ["images"]);
  const productId = payload.productId;
  const productImages = _.get(params, "payload.payload.images", {});

  const selectedProduct = yield select((state) => state.productReviews.selectedProduct);

  const apiString = `api/products/${productId}/`;
  let hasError = false;
  let imageResults = [];

  try {
    const apiResponse = yield apiPatch(apiString, payload);

    const apiResponseStatus = _.get(apiResponse, "status", false);

    if (apiResponseStatus >= 400) {
      hasError = true;
      // Handle barcode error
      if (_.has(apiResponse, "data.barcode.0")) {
        const errorMessage = apiResponse.data.barcode[0];
        setFieldError("barcode", errorMessage);

        toast.error(errorMessage, {
          bodyClassName: "toast-body",
          style: {
            backgroundColor: "#414B4F",
            color: "#ffffff",
          },
          progressStyle: {
            background: "#E74C3C",
          },
          closeButton: true,
          position: "top-right",
          autoClose: 2000,
        });

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        toast.error("The product could not be saved, so no image changes were applied. Please check the form and try again.", ERROR_TOAST_OPTIONS);
      }

      yield put({
        type: UPDATE_SELECTED_PRODUCT_DETAILS_ERROR,
      });

      return;
    }
  } catch (error) {
    console.error(error);
    hasError = true;
  }

  const selectedProductExistingImages = _.get(selectedProduct, "images", []);

  // updates product images
  try {
    const updatedProductImages = Object.keys(productImages);

    if (updatedProductImages.length > 0) {
      imageResults = yield all(
        _.map(updatedProductImages, (value) => {
          const productObject = _.get(productImages, value, {});

          const oldImage = _.get(productObject, "image", {});
          const newImage = _.get(productObject, "newImage", {});

          // update new image in place of old image
          if (newImage?.size > 0) {
            return call(doProductImageUpload, {
              position: productObject.position,
              productId,
              method: _.get(oldImage, "id") || productObject.removedImageId ? "patch" : "post",
              imageId: _.get(oldImage, "id") || productObject.removedImageId || "",
              photo: newImage,
              rotate: _.get(productObject, "rotate", 0),
              operation: _.get(oldImage, "id") || productObject.removedImageId
                ? "updateOldImageWithNew"
                : "updatingNewImage",
            });
          }

          //update image rotation
          if (!_.isEmpty(oldImage)) {
            const imageId = _.get(oldImage, "id");
            const existingImage = _.find(selectedProductExistingImages, ["id", imageId]);

            if (String(existingImage.rotate) !== String(oldImage?.rotate)) {
              return call(doProductImageUpload, {
                method: "patchImageRotateValue",
                rotate: oldImage?.rotate,
                imageId: _.get(oldImage, "id", ""),
                operation: "modifyingOldImage",
              });
            }
          }

          // will delete a product image
          if (_.isEmpty(oldImage) && !newImage?.size) {
            if (productObject.removedImageId) {
              return call(doProductImageUpload, {
                position: productObject.position,
                method: "delete",
                imageId: productObject.removedImageId,
                operation: "deletingImage",
              });
            }
          }
        }),
      );
    }
  } catch (error) {
    console.log(error);
    hasError = true;
  }

  setFieldError("barcode", "");
  if (_.includes(imageResults, false)) {
    toast.error("Product saved, but some image changes could not be applied. Please check the images and try again.", ERROR_TOAST_OPTIONS);
  } else {
    toast.success("Product Saved", {
      bodyClassName: "toast-body",
      style: {
        backgroundColor: "#414B4F",
        color: "#ffffff",
      },
      progressStyle: {
        background: "#00889b",
      },
      closeButton: true,
      position: "top-right",
    });
  }

  yield put({
    type: UPDATE_SELECTED_PRODUCT_DETAILS_SUCCESS,
  });

  // Dispatch clearBarcodeMatches only if no errors occurred
  if (!hasError) {
    yield put({
      type: "CLEAR_BARCODE_MATCHES",
    });
  }

  // Re-fetch product details to refresh form with updated images
  try {
    const response = yield apiGet(`api/products/product-list/${productId}/`);
    yield put({
      type: GET_SELECTED_PRODUCT_DETAILS_SUCCESS,
      response,
    });
  } catch (error) {
    console.error("Error re-fetching product details:", error);
  }
}

function* doGetSelectedProductDetails(action) {
  const productId = action.productId;
  try {
    const response = yield apiGet(`api/products/product-list/${productId}/`);

    yield put({
      type: GET_SELECTED_PRODUCT_DETAILS_SUCCESS,
      response,
    });
  } catch (error) {
    console.error(error);
  }
}

function* doProductImageUpload({ photo, productId, position, method, imageId, rotate = 0, operation }) {
  const formData = new FormData();

  if (method === "post") {
    formData.append("product", productId);
    formData.append("rotate", rotate);
  }

  formData.append("position", position);
  formData.append("image", photo);

  try {
    let response;

    if (method === "post") {
      response = yield apiPost("api/products/upload/", {
        data: formData,
        headers: { "Content-type": "multipart/form-data" },
      });
    }

    if (method === "patch") {
      if (operation === "updateOldImageWithNew") {
        formData.append("rotate", rotate);
      }

      response = yield apiPatch(`api/products/upload/${imageId}/`, {
        data: formData,
        headers: { "Content-type": "multipart/form-data" },
      });
    }

    if (method === "delete") {
      response = yield apiDelete(`api/products/upload/${imageId}/`);
    }

    if (method === "patchImageRotateValue") {
      const patchedFormData = new FormData();

      patchedFormData.append("rotate", rotate);

      response = yield apiPatch(`api/products/upload/${imageId}/`, {
        data: patchedFormData,
        headers: { "Content-type": "multipart/form-data" },
      });
    }

    // apiPost and apiPatch return the response instead of throwing on a 4xx
    if (_.get(response, "status", 0) >= 400) {
      yield put({
        type: PRODUCT_REVIEW_UPLOAD_PRODUCT_PHOTO_ERROR,
        error: _.get(response, "data", response),
      });

      return false;
    }

    yield put({
      type: PRODUCT_REVIEW_UPLOAD_PRODUCT_PHOTO_SUCCESS,
      response,
      operation,
      position,
      imageId,
    });

    return true;
  } catch (error) {
    console.log(error);
    yield put({
      type: PRODUCT_REVIEW_UPLOAD_PRODUCT_PHOTO_ERROR,
      error: _.get(error, "response.data", error.message),
    });

    return false;
  }
}

function* doPublishProduct(action) {
  const params = action;
  const { setFieldError } = params.payload;
  const payload = _.omit(params.payload.payload, ["images"]);
  const productActionStatus = payload.status;
  const productId = payload.productId;
  const productImages = _.get(params, "payload.payload.images", {});
  const selectedProduct = yield select((state) => state.productReviews.selectedProduct);
  const apiString = `api/products/${productId}/`;
  const selectedProductExistingImages = _.get(selectedProduct, "images", []);
  let hasError = false;
  let imageResults = [];

  try {
    const apiResponse = yield apiPatch(apiString, payload);

    const apiResponseStatus = _.get(apiResponse, "status", false);

    // Api failed condition
    if (apiResponseStatus >= 400) {
      hasError = true;
      // Handle barcode error
      if (_.has(apiResponse, "data.barcode.0")) {
        const errorMessage = apiResponse.data.barcode[0];
        setFieldError("barcode", errorMessage);

        toast.error(errorMessage, {
          bodyClassName: "toast-body",
          style: {
            backgroundColor: "#414B4F",
            color: "#ffffff",
          },
          progressStyle: {
            background: "#E74C3C",
          },
          closeButton: true,
          position: "top-right",
          autoClose: 2000,
        });

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        toast.error("The product could not be saved, so no image changes were applied. Please check the form and try again.", ERROR_TOAST_OPTIONS);
      }

      yield put({
        type: UPDATE_SELECTED_PRODUCT_DETAILS_ERROR,
      });

      return;
    }

    // Reject condition
    if (productActionStatus === PRODUCT_REVIEW_CONSTANTS.REJECT) {
      setFieldError("barcode", "");
      toast.error("Product Rejected", {
        bodyClassName: "toast-body",
        style: {
          backgroundColor: "#414B4F",
          color: "#ffffff",
        },
        progressStyle: {
          background: "#E74C3C",
        },
        closeButton: true,
        position: "top-right",
      });

      yield put({
        type: UPDATE_SELECTED_PRODUCT_DETAILS_SUCCESS,
      });
      return;
    }
  } catch (error) {
    console.error(error);
    hasError = true;
  }

  // Handle Image upload logic
  try {
    const updatedProductImages = Object.keys(productImages);

    if (updatedProductImages.length > 0) {
      imageResults = yield all(
        _.map(updatedProductImages, (value) => {
          const productObject = _.get(productImages, value, {});

          const oldImage = _.get(productObject, "image", {});
          const newImage = _.get(productObject, "newImage", {});

          // update new image in place of old image
          if (newImage?.size > 0) {
            return call(doProductImageUpload, {
              position: productObject.position,
              productId,
              method: _.get(oldImage, "id") || productObject.removedImageId ? "patch" : "post",
              imageId: _.get(oldImage, "id") || productObject.removedImageId || "",
              photo: newImage,
              rotate: productObject?.rotate,
              operation: _.get(oldImage, "id") || productObject.removedImageId
                ? "updateOldImageWithNew"
                : "updatingNewImage",
            });
          }

          //update image rotation
          if (!_.isEmpty(oldImage)) {
            const imageId = _.get(oldImage, "id");
            const existingImage = _.find(selectedProductExistingImages, ["id", imageId]);

            if (String(existingImage.rotate) !== String(oldImage?.rotate)) {
              return call(doProductImageUpload, {
                method: "patchImageRotateValue",
                rotate: oldImage?.rotate,
                imageId: _.get(oldImage, "id", ""),
                operation: "modifyingOldImage",
              });
            }
          }

          if (_.isEmpty(oldImage) && !newImage?.size) {
            if (productObject.removedImageId) {
              return call(doProductImageUpload, {
                position: productObject.position,
                method: "delete",
                imageId: productObject.removedImageId,
                operation: "deletingImage",
              });
            }
          }
        })
      );
    }
  } catch (error) {
    console.log(error);
    hasError = true;
  }
  setFieldError("barcode", "");
  if (_.includes(imageResults, false)) {
    toast.error("Product published, but some image changes could not be applied. Please check the images and try again.", ERROR_TOAST_OPTIONS);
  } else {
    toast.success("Product has been published", {
      bodyClassName: "toast-body",
      style: {
        backgroundColor: "#414B4F",
        color: "#ffffff",
      },
      progressStyle: {
        background: "#00889b",
      },
      closeButton: true,
      position: "top-right",
    });
  }

  yield put({
    type: UPDATE_SELECTED_PRODUCT_DETAILS_SUCCESS,
  });

  // Dispatch clearBarcodeMatches only if no errors occurred
  if (!hasError) {
    yield put({
      type: "CLEAR_BARCODE_MATCHES",
    });
  }

  // Re-fetch product details to refresh form with updated images
  try {
    const response = yield apiGet(`api/products/product-list/${productId}/`);
    yield put({
      type: GET_SELECTED_PRODUCT_DETAILS_SUCCESS,
      response,
    });
  } catch (error) {
    console.error("Error re-fetching product details:", error);
  }
}

function* doGetIngredientLogs(action) {
  const { productId, sorting, filter } = action.payload;

  try {
    const baseUrl = "api/audit-trail/ingredient-update-logs/";
    const params = new URLSearchParams({
      product: productId,
      ordering: sorting,
    });

    if (filter === "active") {
      params.append("is_active", "true");
    } else if (filter === "inactive") {
      params.append("is_active", "false");
    }

    const encodedUrl = `${baseUrl}?${params.toString()}`;

    const response = yield call(apiGet, encodedUrl);

    yield put({
      type: SET_INGREDIENT_LOGS,
      payload: {
        logs: response.results,
        next: response.next,
        previous: response.previous,
      },
    });
  } catch (error) {
    console.error(error);
    yield put({
      type: SET_FETCHING_ERROR,
      payload: error.message,
    });
  }
}

function* doGetIngredientLogsNext(action) {
  const nextUrl = action.payload;
  const baseUrl = yield select((state) => state.env.api_root);
  const url = nextUrl.replace(baseUrl, "");

  const existingLogs = yield select((state) => state.productReviews.logs || []);

  try {
    const response = yield apiGet(url);

    yield put({
      type: SET_INGREDIENT_LOGS,
      payload: {
        logs: [...existingLogs, ...response.results],
        next: response.next,
        previous: response.previous,
      },
    });
  } catch (error) {
    console.error(error);
    yield put({
      type: SET_FETCHING_ERROR,
      payload: error.message,
    });
  }
}

function* doGetBarcodeMatches(action) {
  const barcode = action.payload;
  try {
    const response = yield apiGet(`/api/products?barcode=${barcode}`);
    yield put({
      type: GET_BARCODE_MATCHES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: GET_BARCODE_MATCHES_FAILURE,
      payload: error.message,
    });
  }
}

export default function* productReviewSagas() {
  yield takeLatest(GET_PRODUCT_REVIEW_LAST_UPDATED_DATE, doGetProductReviewLastUpdatedDate);
  yield takeLatest(GET_PRODUCT_REVIEWS, doGetProductReviews);
  yield takeLatest(GET_PRODUCT_REVIEWS_NEXT, doGetProductReviewsNext);
  yield takeEvery(UPDATE_PRODUCT_REVIEW_STATUS, doUpdateProductStatus);
  yield takeLatest(GET_SELECTED_PRODUCT_DETAILS, doGetSelectedProductDetails);
  yield takeLatest(UPDATE_SELECTED_PRODUCT_DETAILS, doSaveProductDetails);
  yield takeEvery(DO_UPDATE_PRODUCT_REVIEW_PHOTOS, doProductImageUpload);
  yield takeLatest(PUBLISH_SELECTED_PRODUCT_DETAILS, doPublishProduct);
  yield takeLatest(GET_INGREDIENT_LOGS, doGetIngredientLogs);
  yield takeLatest(GET_INGREDIENT_LOGS_NEXT, doGetIngredientLogsNext);
  yield takeLatest(GET_BARCODE_MATCHES, doGetBarcodeMatches);
}
